<div class="container">
  <app-validation-header>
    <ng-template #centerContent>
      <div class="center-content-wrapper">
        <div title>Validation Report</div>
        <div sub-title>
          Change Request: <a [routerLink]="['/change-request/edit', updateNoticeId]"> {{ updateNotice()?.name }} </a>
        </div>
      </div>
    </ng-template>
    <!-- <ng-template #rightContent>
      <button
        mat-button
        (click)="backToHistory()">
        Validation History
      </button>
    </ng-template> -->
  </app-validation-header>
  @if (loaders()?.['getReportSummary']) {
  <mat-progress-bar
    color="accent"
    mode="indeterminate"></mat-progress-bar>
  }
  <mat-card class="validation-report-section mat-elevation-z0">
    <mat-card-content>
      <!-- Summary Section -->
      <div class="report-summary">
        <!-- Summary Component -->
        <app-validation-report-summary
          [reportSummaryInput]="reportSummary()"
          [rowConfig]="rowConfig"
          [customRowTpl]="{ businessRules }"
          [customContentTpl]="{ result }">
          <ng-template
            #result
            let-data>
            <div
              content
              class="summary-badge"
              [class]="data?.validationReportStatus?.toLowerCase()">
              <mat-icon [color]="badgeIconLookup[data?.validationReportStatus?.toLowerCase()]?.color">
                <span class="material-symbols-outlined">
                  {{ badgeIconLookup[data?.validationReportStatus?.toLowerCase()]?.icon }}
                </span>
              </mat-icon>
              <span>
                {{ data?.validationReportStatus }}
              </span>
            </div>
          </ng-template>
          <ng-template
            #businessRules
            let-data>
            <div class="row gap align-start">
              <div label>Business Rules <span>:</span></div>
              <div
                content
                class="row gap wrap">
                @for (rule of data?.bizRuleList; track $index) {
                <span class="badge">{{ rule?.name }}</span>
                }
              </div>
            </div>
          </ng-template>
        </app-validation-report-summary>
      </div>
      @if (false) {
      <div class="disclaimer-text">
        Disclaimer: this validator checks the input dataset against technical and operational rules as selected in the
        interface. It does not verify the correctness of the data but only its conformance to these rules.
      </div>
      }
      <!-- Table section -->
      <div class="report-table">
        <div
          class="tool-section"
          [formGroup]="filters">
          <div class="filter-section">
            <mat-form-field
              appearance="outline"
              class="filter-input custom-density">
              <mat-label>Search</mat-label>
              <input
                matInput
                formControlName="search"
                (keyup)="onSearch($event)" />
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>

          <div class="group-section">
            <mat-checkbox
              formControlName="groupToggle"
              class="group-checkbox"
              color="primary"
              (change)="onGroupToggle($event)">
              <mat-label>Group</mat-label>
            </mat-checkbox>
            <mat-form-field class="group-input custom-density">
              <mat-label>Group By</mat-label>
              <mat-select
                formControlName="groupBy"
                (selectionChange)="onGroupBySelected()">
                @for (item of groupedByConfig; track $index) {
                <mat-option [value]="item.value">{{ item.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="button-group">
            <button
              [disabled]="filters.disabled"
              mat-flat-button
              color="primary"
              (click)="toggleExpandAll()">
              {{ expandAll() ? "Collapse All" : "Expand All" }}
            </button>
            <button
              (click)="exportToCsv()"
              [disabled]="filters.disabled"
              mat-flat-button
              color="primary">
              Export to CSV
            </button>
          </div>
        </div>
        <!-- Report table -->
        <app-validation-report-table
          [reportListData]="reportSummary()?.reportList"
          [selectedGroupValue]="filters.get('groupBy').value"
          [expandedState]="expandAll()"></app-validation-report-table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
